import { render, staticRenderFns } from "./SalesData.vue?vue&type=template&id=0f89252a&scoped=true"
import script from "./SalesData.vue?vue&type=script&lang=js"
export * from "./SalesData.vue?vue&type=script&lang=js"
import style0 from "./SalesData.vue?vue&type=style&index=0&id=0f89252a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f89252a",
  null
  
)

export default component.exports